import React, {
  createContext,
  useState,
  useMemo,
  FunctionComponent,
  useContext,
  PropsWithChildren,
} from "react";
import {AdmissionFromSearch} from "../../../../services/AdmissionsService";

type Context = Readonly<{
  admission?: AdmissionFromSearch;
  openModal: (admission: AdmissionFromSearch) => void;
  closeModal: () => void;
}>;

const ChangeHistoryModalContext = createContext<Context>(undefined);

export const ChangeHistoryModalProvider: FunctionComponent<
  PropsWithChildren<{}>
> = ({children}) => {
  const [admission, setAdmission] = useState<AdmissionFromSearch>(undefined);

  const value = useMemo(
    () => ({
      admission,
      openModal: setAdmission,
      closeModal: () => setAdmission(undefined),
    }),
    [admission, setAdmission],
  );

  return (
    <ChangeHistoryModalContext.Provider value={value}>
      {children}
    </ChangeHistoryModalContext.Provider>
  );
};

export const useChangeHistoryModalContext = () =>
  useContext(ChangeHistoryModalContext);

export const ChangeHistoryModalConsumer = ChangeHistoryModalContext.Consumer;
